import { useMutation } from '@tanstack/react-query'

import type { GetEnvelopeResponse } from '@/api/v1/ecm/envelopes/get-envelope'
import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { UpdateEnvelopeRequest } from './update-envelope.types'

interface UpdateEnvelopeParams {
  envelopeId: string
  payload: UpdateEnvelopeRequest
}

const updateEnvelope = async (
  params: UpdateEnvelopeParams,
): Promise<GetEnvelopeResponse> => {
  const response = await apiClient.put<GetEnvelopeResponse>(
    `/v1/ecm/envelopes/${params.envelopeId}`,
    params.payload,
  )
  return response.data
}

export const useUpdateEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (params: UpdateEnvelopeParams) => updateEnvelope(params),
    meta: {
      invalidatesQuery: 'envelopes',
      ...feedback,
    },
  })
}
